<script setup>
import { useWebSiteStore } from '@/stores/web-site.store'

const webSiteStore = useWebSiteStore()

const logoSrc = webSiteStore.getLogo(false)

</script>
<template>
  <div class="container">
    <transition
      appear
      name="slide-fade"
    >
      <img
        :src="logoSrc"
        alt="Logo"
        class="logo"
      >
    </transition>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
.logo {
  display: flex;
  height: 12rem;
}

</style>
